import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    required,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import { Page } from '../types';

const req = [required()];

const EntityCreate = () => {
    const optionRenderer = (choice: Page) =>
        `${choice.title_selector} (${choice.geo_id}/${choice.fias_id})`;
    const dataTransform = (data: Page) => ({
        ...data,
        type: 'override',
    });

    return (
        <>
            {/* @ts-ignore */}
            <Create
                resource="logix_geo_map_overrides"
                transform={dataTransform}
            >
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <ReferenceInput
                        source="from_geo_id"
                        reference="logix_cities"
                        filter={{ type: 'locality' }}
                    >
                        <AutocompleteInput
                            optionText={optionRenderer}
                            fullWidth
                            validate={req}
                            isRequired
                        />
                    </ReferenceInput>
                    <ReferenceInput source="to_geo_id" reference="logix_cities">
                        <AutocompleteInput
                            optionText={optionRenderer}
                            fullWidth
                            validate={req}
                            isRequired
                        />
                    </ReferenceInput>
                    <TextInput source="description" fullWidth />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
